import { render, staticRenderFns } from "./mianBao.vue?vue&type=template&id=2d4b4c47&"
import script from "./mianBao.vue?vue&type=script&lang=js&"
export * from "./mianBao.vue?vue&type=script&lang=js&"
import style0 from "./mianBao.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports